import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppContainer from './appContainer';
import * as serviceWorker from './serviceWorker';

const MOUNT_NODE = document.getElementById('root');

ReactDOM.render(<AppContainer />, MOUNT_NODE);

navigator.serviceWorker.register('/OneSignalSDKWorker.js');

serviceWorker.register();
